var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyoptions1Cfe240(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3288 2H7.67123C3.39726 2 0 5.54286 0 10C0 14.4571 3.39726 18 7.67123 18H24.3288C28.6027 18 32 14.4571 32 10C32 5.54286 28.4932 2 24.3288 2ZM1.31507 10C1.31507 6.34286 4.16438 3.37143 7.67123 3.37143H18.5205L15.1233 16.6286H7.67123C4.16438 16.6286 1.31507 13.6571 1.31507 10Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5205 6.57144C26.7397 6.80001 26.7397 7.25715 26.5205 7.48572L24.2191 10L26.6301 12.5143C26.8493 12.7429 26.8493 13.2 26.6301 13.4286C26.4109 13.6572 25.9726 13.6572 25.7534 13.4286L23.3424 10.9143L20.9315 13.4286C20.7123 13.6572 20.2739 13.6572 20.0548 13.4286C19.8356 13.2 19.8356 12.7429 20.0548 12.5143L22.3561 10L19.9452 7.48572C19.726 7.25715 19.726 6.80001 19.9452 6.57144C20.1644 6.34287 20.6027 6.34287 20.8219 6.57144L23.2328 9.08572L25.6438 6.57144C25.863 6.34287 26.3013 6.34287 26.5205 6.57144Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4794 6.68571C13.6986 6.91428 13.8082 7.37143 13.589 7.6L8.98628 13.2C8.87669 13.3143 8.7671 13.4286 8.65751 13.4286C8.43834 13.5429 8.10957 13.5429 7.89039 13.3143L5.47943 10.8C5.26025 10.5714 5.26025 10.1143 5.47943 9.88571C5.69861 9.65714 6.13697 9.65714 6.35614 9.88571L8.32875 11.8286L12.4931 6.68571C12.7123 6.45714 13.1507 6.45714 13.4794 6.68571Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyoptions1Cfe240);
export default __webpack_public_path__ + "static/media/privacyoptions.1cfe240.257f50eb497ceeeaea28324ec868b43a.svg";
export { ForwardRef as ReactComponent };